(function ($, window, document, undefined) {
  var self,
    smoothState,
    hostname = wp_ajax.hostname,
    $body = $("body"),
    $html = $("html");

  $.extend(App.prototype, {
    init_ajax: function () {
      self = this;

      var transition = "",
        content = "#content",
        duration_out,
        duration_in,
        new_path = "",
        anchor,
        options = {
          prefetch: false,
          debug: true,
          cacheLength: 0,
          anchors: 'a[href*="' + hostname + '"]',
          blacklist:
            "[href=\"#\"], [target=\"_blank\"], .no-address, [href$='jpg'], [href$='jpeg'], [href$='gif'], [href$='png'], [href$='pdf']",
          loadingClass: "is-loading",
          forms: ".ajax-form",
          scroll: false,
          onBefore: function ($anchor, $container) {
            anchor = $anchor;

            anchor.data(
              "back-button",
              anchor.data("back-button") ? anchor.data("back-button") : ""
            );

            if ($anchor.attr("href")) {
              new_path = $anchor.attr("href").replace(wp_ajax.hostname, "");
            }
          },
          onStart: {
            duration: 1000,
            render: function ($container) {
              smoothState.restartCSSAnimations();

              if (anchor && anchor.data("transition") == "filter") {
                transition = "filter";
              } else if (
                Foundation.MediaQuery.current == "small" ||
                Foundation.MediaQuery.current == "medium"
              ) {
                transition = "mobile";
              } else if (anchor && anchor.data("transition")) {
                transition = anchor.data("transition");
              } else {
                transition = "fade";
              }

              $("html").removeClass("page-loaded side-nav-open");
              $container.addClass(
                "transitioning transition-" +
                  transition +
                  " transition-" +
                  transition +
                  "-out"
              );

              // NProgress.start();
            },
          },
          onReady: {
            duration: 0,
            render: function ($container, $newContent) {
              // NProgress.set(0.4);

              var preload_objects = $newContent.find(".do-preload"),
                new_content = $newContent.find(content),
                content_elem = $(content);

              var preload_images = function (callback) {
                var image_containers = $(".column-header-photo");

                if (image_containers.length) {
                  var imgs = [];

                  image_containers.one("replaced.zf.interchange", function () {
                    var img = $("<img>");
                    img.attr("src", bg_to_src($(this).css("background-image")));

                    imgs.push(img);

                    if (imgs.length == image_containers.length) {
                      Foundation.onImagesLoaded($(imgs), callback);
                    }
                  });
                } else {
                  callback.call();
                }
              };

              var show_new_page = function (speed) {
                if (!speed) {
                  speed = 1500;
                }

                $container
                  .removeClass("transition-" + transition + "-out")
                  .addClass("transition-" + transition + "-in");

                setTimeout(
                  function () {
                    $container.removeClass(
                      "transitioning transition-" +
                        transition +
                        " transition-" +
                        transition +
                        "-in transition-" +
                        transition +
                        "-out"
                    );

                    transition = false;
                    anchor = false;

                    $("#bg-gradient, .background-image-slider-wrapper").attr(
                      "style",
                      ""
                    );

                    // NProgress.done();
                  },
                  Foundation.MediaQuery.current == "small" ||
                    Foundation.MediaQuery.current == "medium"
                    ? 1000
                    : speed
                );
              };

              var load_new_page = function () {
                // NProgress.set(0.7);

                //$('.cb-slider.slick-initialized').slick('unslick');
                content_elem.html(new_content.html());
                $body.attr("class", new_content.data("body-classes"));

                $("body, html").scrollTop(0);
                self.set_active_menu();

                if (anchor && anchor.data("back-button")) {
                  var back_text =
                    anchor.data("back-text") || wp_ajax.back_button;

                  $(".back-button")
                    .attr("href", anchor.data("back-button"))
                    .removeClass("hidden")
                    .children(".link-label")
                    .text(back_text);
                } else {
                  $(".back-button").addClass("hidden");
                }

                preload_images(function () {
                  if (transition == "case") {
                    self.load_case(function () {
                      show_new_page(1200);
                    });
                  } else if (transition == "theme") {
                    self.load_theme(function () {
                      show_new_page(1200);
                    });
                  } else if (transition == "from-home") {
                    show_new_page(1750);
                  } else if (transition == "to-home") {
                    show_new_page(1300);
                  } else if (transition == "purple") {
                    show_new_page(1200);
                  } else {
                    show_new_page();
                  }
                });

                self.init_page_scripts();
                self.init_page();
              };

              load_new_page();
            },
          },
        };

      smoothState = $("#ss-container").smoothState(options).data("smoothState");
    },
    load_theme: function (callback) {
      var gbg = $(".gradient-bg"),
        header_height = gbg.outerHeight();

      gbg.css("height", "100vh");

      setTimeout(function () {
        gbg
          .addClass("has-transition")
          .height(header_height)
          .one(transitionEnd, function () {
            gbg.removeClass("has-transition");
            callback.call();
          });
      }, 1);
    },
    load_case: function (callback) {
      var header_height = $(".column-header").outerHeight();

      $(".background-image-slider-wrapper").height(header_height);

      $("#bg-gradient")
        .css({
          width: $(".column-header-gradient").outerWidth(),
        })
        .one(transitionEnd, callback);
    },
    init_page: function () {
      document.body.className = document.body.className;

      $(document).foundation();

      if (typeof __gaTracker != "undefined") {
        __gaTracker("send", "pageview", smoothState.href.replace(hostname, ""));
      }

      /** Check if Online Success plugin is added */
      if (typeof window.image !== "undefined") {
        var image = document.createElement("img");
        image.src =
          "//connect.onlinesucces.nl/?i=df25d4dc12d884b93451a0c3f1fe65bfb02c2d8a&ts=" +
          new Date().getTime() +
          "&f=" +
          encodeURIComponent(document.location.href) +
          "&r=" +
          encodeURIComponent(document.referrer) +
          "&t=" +
          encodeURIComponent(document.title);
      }

      // if($('.nf-form-cont').length){
      //
      //    $.getScript('http://dev.inspire.nl/user-files/plugins/ninja-forms/assets/js/min/front-end.js?ver=3.0.14', function(){
      //        log(Object.keys( window ));
      //    });
      // }

      $(".success-hover:not(#success-hover-0)").removeClass("visible");

      $(document).ready();
      $(window).trigger("load");
    },
    set_active_menu: function (url) {
      if (!url) {
        url = smoothState.href;
      }

      var clickedlink = $('a[href="' + url + '"]:not([lang])');
      if (clickedlink.length) {
        $(".current-menu-item, .current-cat").removeClass(
          "mm-selected current-menu-item current-cat"
        );
        clickedlink
          .parents("li")
          .addClass("mm-selected current-menu-item current-cat");
      } else {
        url = url.replace(/https?:\/\//, "").split("/");
        url = url.slice(2);

        for (var i = 0, len = url.length; i < len; i += 1) {
          clickedlink = $('.menu a[href*="' + url[i] + '"]:not([lang])');
          if (clickedlink.length > 0) {
            $(".current-menu-item, .current-cat").removeClass(
              "mm-selected current-menu-item current-cat"
            );
            clickedlink
              .parents("li")
              .addClass("mm-selected current-menu-item current-cat");
            return;
          }
        }
      }
    },
  });
})(jQuery, window, document);
